export class SampleModel {
    constructor (jsonObj) {
      this.color = jsonObj.color || '#5e3f63'
      this.value = Number(jsonObj.value) || null
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./~/@microbadevs/report/src/model/sample.js
// module id = RC4q
// module chunks = 0